<template>
  <main class="content">
      <div class="row u-wa">
          <h1>
              Partners
          </h1>
      </div>
      <div class="topBar u-wa u-fright">
          <div class="topBar--item_right">
              <router-link to="/partners/add" class="btn btn_blue">
                 Add new partner
              </router-link>
          </div>
      </div>
      <div class="table">
          <div class="table--row table--row_header">
            
              <div v-bind:class="getSortClasses('name')" style="max-width:481px" @click="sort('name')">
                  <div class="table--col-title">
                      Name
                      <div class="table--col-arrows">
                          <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
                          <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
                      </div>
                  </div>
              </div>
              <div v-bind:class= "getSortClasses('revenueShare')" style="max-width:739px" @click="sort('revenueShare')">
                  <div class="table--col-title">
                      Percentage of revenue shared
                      <div class="table--col-arrows">
                          <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
                          <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
                      </div>
                  </div>
              </div>
              <div class="table--col" style="max-width:96px">
              </div>
          </div>
          <div class="table--row" v-for="partner in partners">
              <div class="table--col" style="max-width:481px">
                  <strong>
                      {{partner.name}}
                  </strong>
              </div>
              <div class="table--col" style="max-width:739px">
                  <strong>
                      {{(partner.revenueShare * 100).toFixed(2)}}%
                  </strong>
              </div>
              <div class="table--col" style="max-width:96px">
                  <router-link :to="{ name: 'EditPartners', params: { id: partner.id }}" class="btn btn btn_blueLight">
                    Edit
                  </router-link>
              </div>
          </div>
      </div>
      <a class="btn btn_green u-fleft" @click="fetchResource()" v-if="nextPage">
          Load more
      </a>
      <loading :visible.sync="loadingVisible"></loading>
  </main>
</template>
<script>
import * as ListResource from '../../mixins/listResource.mixin';
import Loading from '../Loading.vue'

export default {
  name: 'Partners',
  components: {Loading},
  mixins: [ListResource],
  data () {
    return {
      model: 'partners',
      resource: 'partners',
      partners: [],
      sortOrder: 'asc',
      sortAttribute: 'name'
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Partners.vue?54dadd0d